const withoutExtension = (name: string) => name.replace(/\.[^/.]+$/, '');

const decoded = (value: string) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

/**
 * What a click on a link in an agent reply does: download the chat file it names, open an http(s) page in a new
 * tab, or nothing (mailto, in-page fragments). The href arrives percent-encoded and is decoded first. A file is
 * matched by its exact name, then, for a relative href, by the href's last path segment (the agent may link the
 * sandbox path, e.g. «extra/<name>.csv») with or without the extension. Same-name files resolve to the newest.
 */
export const replyLinkTarget = <F extends { name: string }>(href: unknown, files: F[] | undefined): { file: F } | { url: string } | null => {
  const value = String(href ?? '');
  const name = decoded(value);
  const relative = !/^[a-z][a-z0-9+.-]*:/i.test(value);
  const segment = name.split('/').pop() ?? '';
  // Oldest first in the chat, so search a reversed copy (Array.prototype.findLast is missing in older browsers).
  const newestFirst = [...(files ?? [])].reverse();
  const file =
    newestFirst.find((candidate) => candidate.name === name) ??
    (relative && segment
      ? newestFirst.find((candidate) => candidate.name === segment || withoutExtension(candidate.name) === segment)
      : undefined);
  if (file) return { file };
  if (/^https?:\/\//i.test(value)) return { url: value };
  return null;
};
